import React from 'react'
import './about.css'


function AboutUs() { 
  return (
    <div className='about-container mb-5 mt-5'>
    <h3 className='mb-5'>OM OSS</h3>
    <div className='row '>
      <div className='col-sm-12 col-md-6 col-image mb-3 col-about'></div>
      <div className='col-sm-12 col-md-6 content-about col-about'>
        <p className=''>
        Det finns vissa situationer när en familj eller individ behöver lägga till ett befintligt gravsten efter att det har placerats på en kyrkogård.
Oavsett om ett gravsten nyligen sattes eller det har legat på en kyrkogård i årtionden, kan vi lägga till bokstäver till ett befintligt gravsten , precis på kyrkogården. Den tillagda minnesinskriften är färdig med samma precision och hantverk som  samma  gamla inskriptionen.
Potentiella tillägg till en sten inkluderar:
<ul>
  <li>Sista datum
</li>
<li>Namn på andra familjemedlemmar på ett familjegravsten. 
</li>
<li>Meningsfulla citat, böner eller fraser. 
</li>
<li>Religiösa symboler. 
</li> 
</ul>
Allt som passar på det tillgängliga utrymmet.
Vi är tillgängliga när som helst.
Med  hälsningar Ljusa toppar.</p>
      </div>
    </div>
    </div>
  )
}

export default AboutUs